var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery",class:[_vm.excludeFromPrintClassName]},_vm._l((_vm.value),function(image,index){return _c('div',{key:index,staticClass:"galery_item"},[_c('picture',{directives:[{name:"full-image-path",rawName:"v-full-image-path",value:(image || {}),expression:"image || {}"}]})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }